export default "__VITE_ASSET__9e2c0809__"